import { defineStore } from 'pinia';
import ConvertQuoteBookingService from '@/service/ConvertQuoteBookingService';

export const useConvertQuoteBookingStore = defineStore('convertQuoteBookingStore', {
  state: () => ({}),
  getters: {},
  actions: {
    handleAddBookingId(quoteId, payload) {
      const convertQuoteBookingService = new ConvertQuoteBookingService();
      return convertQuoteBookingService.addBookingId(quoteId, payload);
    },
    updateBookingById(quoteId, payload) {
      const convertQuoteBookingService = new ConvertQuoteBookingService();
      return convertQuoteBookingService.updateBookingById(quoteId, payload);
    }
  }
});
